import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss'],
})
export class CustomTooltipComponent implements ITooltipAngularComp {
  public data: any | any[];

  agInit(params: ITooltipParams): void {
    if (typeof (params.value) == "string") {
      let ogText = params.value.trim() as string;
      if (ogText.includes('\n')) {
        this.data = ogText.split('\n');
      }
      else if (ogText.includes(',')) {
        this.data = ogText.split(',');
      }
      else if (ogText.includes(';')) {
        this.data = ogText.split(';');
      }
      else {
        this.data = [ogText];
      }
    }
    else {
      let separator = params.value.separator;
      let data = params.value.data;
      this.data = data.trim().split(separator);
    }
  }
}
